<template>
  <div class="w224 bgwhite ht317 plr14">
    <div v-if="isshowit==='true'">
        <div class="ht602">
        Hi，
        <span class="color_sub">{{username}}</span>，
        <br />欢迎来到物流{{comUrl.nodeCity.name}}！
      </div>
    </div>
    <div v-else>
    <div class="ht45">Hi，欢迎来到物流{{comUrl.nodeCity.name}}！</div>
      <router-link :to="{name:'login'}" class="blue_botton">登录</router-link>
      <router-link :to="{name:'register'}" class="blue_botton blue_border ml5">注册</router-link>
    
    </div>
    <div class="fasttle">
      <span class="f16 color3">快捷通道</span>
      <span class="f12">无需注册，快速反馈</span>
    </div>
    <el-form ref="form" :model="form" :rules="rules" class="mt10 fasterr"  :show-message="false">
      <el-form-item>
        <el-input type="textarea" v-model="form.desc" placeholder="请填写您的需求，我们会在第一时间回复您！"></el-input>
      </el-form-item>
      <el-form-item required="">
        <el-col :span="10">
        <el-form-item  prop="name">
          <el-input v-model="form.name" placeholder="姓名"></el-input>
        </el-form-item>
        </el-col>
        <el-col :span="14" class="_ml1">
        <el-form-item  prop="phone">
          <el-input v-model="form.phone" placeholder="手机号"></el-input>
        </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmitfast('form')" class="blue_botton ht30 w224 mt15">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: "fastchannel",
  data() {
    return {
      show: true,
      username: (localStorage.getItem("companyName")==null)?'':localStorage.getItem("companyName"),
      isshowit: (localStorage.getItem("islogin")==null)?'false':localStorage.getItem("islogin"),
      form: {
        name:"",// (localStorage.getItem("userName")==null)?'':localStorage.getItem("userName"),
        phone: "",//(localStorage.getItem("userphone")==null)?'':localStorage.getItem("userphone"),
        desc: ""
      },
      rules: {
        name: [{ required: true, message: "请输入姓名" }],
        phone: [{ required: true, message: "请输入手机号" },{ pattern:/^1(3|4|5|7|8|9)\d{9}$/, message: "请输入合法手机号", trigger: "blur" }
         ]
      }
    };
  },
  created(){
    console.log(this.isshowit,'登录状态')
  },
  methods: {
    getInformation() {
      //获取列表
      let data = {
        nvcDemandContent: this.form.name,
        nvcContact: this.form.desc,
        nvcPhone: this.form.phone,
        resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
        nvcResourceNode: this.comUrl.nodeCity.resourcePlatform,
        iNodeType: this.comUrl.nodeCity.nodeType
      };
      console.log(data, "快捷通道");
      this.$axios
        .post(
          "/information/OrderService/saveFastWay",
          data
        )
        .then(res => {
          console.log(res, '通道数据');
          if (res.data.isSuccess > 0) {
            this.$message({
              message: "提交成功",
              type: "success"
            });
          } else {
            this.$message.error({
                message: res.data.errorMesg
              });
          }
        });
    },
    onSubmitfast(formName) {
      debugger;
        let that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          console.log(valid, "校验");
          that.getInformation();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style scoped>
.fasttle {
  padding-top: 20px;
  line-height: 20px;
  overflow: hidden;
  clear: both;
}
</style>


// WEBPACK FOOTER //
// src/components/Public/fastChannel.vue